// extracted by mini-css-extract-plugin
module.exports =  {"searchTags":"SearchTagList-module_searchTags_ab54a"};